/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Search_NothingInputs */

const en_us2_search_nothing = /** @type {(inputs: Search_NothingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing in the app matches “${i?.query}”. Your trainer can answer:`)
};

const pt_br2_search_nothing = /** @type {(inputs: Search_NothingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nada no app com «${i?.query}». Seu personal pode responder:`)
};

const es_419_search_nothing = /** @type {(inputs: Search_NothingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nada en la app coincide con “${i?.query}”. Tu entrenador puede responder:`)
};

const pt_pt2_search_nothing = /** @type {(inputs: Search_NothingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nada na app corresponde a «${i?.query}». O teu treinador pode responder:`)
};

const fr_fr2_search_nothing = /** @type {(inputs: Search_NothingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rien dans l'app pour « ${i?.query} ». Ton coach peut répondre :`)
};

const de_de2_search_nothing = /** @type {(inputs: Search_NothingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nichts in der App passt zu „${i?.query}“. Dein Coach kann antworten:`)
};

const it_it2_search_nothing = /** @type {(inputs: Search_NothingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Niente nell'app corrisponde a «${i?.query}». Il tuo coach può rispondere:`)
};

/**
* | output |
* | --- |
* | "Nothing in the app matches “{query}”. Your trainer can answer:" |
*
* @param {Search_NothingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_nothing = /** @type {((inputs: Search_NothingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_NothingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_nothing(inputs)
	if (locale === "es-419") return es_419_search_nothing(inputs)
	if (locale === "pt-PT") return pt_pt2_search_nothing(inputs)
	if (locale === "fr-FR") return fr_fr2_search_nothing(inputs)
	if (locale === "de-DE") return de_de2_search_nothing(inputs)
	if (locale === "it-IT") return it_it2_search_nothing(inputs)
	return en_us2_search_nothing(inputs)
});
export { search_nothing as "search.nothing" }